import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ReactComponent as Favorite } from '../../../../Res/svg/favorite.svg';
import { deleteFavoriteBox, updateFavoriteBox, getSetFavoriteBox } from '../../../../actions/EpikBoxes';
import { useSelector } from 'react-redux';
import TooltipCustom from '../../EpikBoxDetails/TooltipCustom';
import './index'
const FavoriteButton = ({ boxId }) => {
  const dispatch = useDispatch();
  const favBoxes = useSelector(state => state.AppState.getSetFavBoxes);
  const userFavBoxes = useSelector(state => state.AppState.favoriteBoxes);
  const token = localStorage.getItem('jwtToken') || null;
  const [favoriteStatus, setFavoriteStatus] = useState(false);

  useEffect(() => {
    let favoriteStatus = false;
    if (favBoxes?.length) {
      favoriteStatus = favBoxes?.includes(boxId);
    } else {
      favoriteStatus = userFavBoxes?.some(favBox => favBox._id === boxId);
    }

    setFavoriteStatus(favoriteStatus);
  }, []);

  const onFavoritePress = async (action) => {
    if (action === 'add') {
      await dispatch(updateFavoriteBox(token, boxId));
      const favoriteBoxes = userFavBoxes?.map(filteredBox => filteredBox._id);
      dispatch(getSetFavoriteBox([...favoriteBoxes, boxId]))
      setFavoriteStatus(true);
    } else if (action === 'remove') {
      await dispatch(deleteFavoriteBox(token, boxId));
      setFavoriteStatus(false);
      const filteredBoxes = userFavBoxes?.filter(box => box._id !== boxId)?.map(filteredBox => filteredBox._id);
      dispatch(getSetFavoriteBox(filteredBoxes))
    }
  }


  return favoriteStatus ? (
    <>
      <Favorite
        fill="#4d9cd3"
        id="remove-fav"
        className="favorite-btn"
        role="button"
        tabIndex={0}
        aria-label="Remove from favorites"
        onClick={() => onFavoritePress('remove')}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') onFavoritePress('remove');
        }}
      />
      <span role="presentation" aria-hidden="true">
        <TooltipCustom
          tipId="remove-fav"
          displayData="Remove from favorites"
          placement="top"
        />
      </span>
    </>
  ) : (
    <>
      <span role="presentation" aria-hidden="true">
        <TooltipCustom
          tipId="add-fav"
          displayData="Add to favorites"
          placement="top"
        />
      </span>
      <Favorite
        id="add-fav"
        className="favorite-btn"
        role="button"
        tabIndex={0}
        aria-label="Add to favorites"
        onClick={() => onFavoritePress('add')}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') onFavoritePress('add');
        }}
      />
    </>
  );
}

export default FavoriteButton
